import NavigationBar from "../../components/navigationBar";
import SetupExplainerComponent from "../../components/explainer-pages/setupExplainerComponent";
import FooterView from "../../components/footerView";


export default function SetupExplainerPage() {


    return (
        <div>
            <NavigationBar />
            <SetupExplainerComponent />
            <FooterView />
        </div>
    )
}